const modalDefaultState = {
  openModalImportSheet: false, // open modal import sheet file
  isAIRequestLimitModalVisible: false,
  isShowModalTemplateLibrary: false,
}

export default modalDefaultState
